import React from 'react';
import Loader from '@appComponents/Loader/Loader';
import PortfolioPage from './pages/PortfolioPage/PortfolioPage';
import PortfolioDetailsPage from './pages/PortfolioDetailsPage/PortfolioDetailsPage';
import { IPortfolioApp } from './IPortfolioApp';
import { connect } from 'react-redux';
import { setPortfolioData, setAdditionalPortfolioData } from './features/action.portfolio';
import { TReducers } from '@features/reducers';
import { unauthorizedPushNotification } from '@features/utils/reactFunctions';
import { IPortfolioCompany } from './IPortfolioReducer';

type TPortfolioApp = {
  loaded: boolean;
};

export class PortfolioApp extends React.Component<IPortfolioApp, TPortfolioApp> {

  state = { loaded: false };

  componentDidMount() {
    if (!this.props.has_investments) {
      unauthorizedPushNotification(this.unauthorizedRedirect);
      return;
    }
    this.props.setPortfolioData().then(() => {
      this.props.setAdditionalPortfolioData(this.props.companies);
      this.setState({ loaded: true });
    });
  }

  unauthorizedRedirect = () => this.props.history.replace(`/profile/${this.props.match.params.slug}/membership`);

  renderApp = () => {
    switch (this.props.match.params.subpage) {
      case 'details':
        return <PortfolioDetailsPage />;
      default:
        return <PortfolioPage />;
    }
  }

  render() {
    return (
      <>
        {this.state.loaded
          ? this.renderApp()
          : <Loader moreSpace={true} />
        }
      </>
    );
  }
}

const mapStateToProps = (store: TReducers) => ({
  has_investments: store.userInfo.has_investments,
  companies: store.portfolioReducer.companies,
});

const mapDispatchToProps = (dispatch: Function) => ({
  setPortfolioData: () => (
    dispatch(setPortfolioData())
  ),
  setAdditionalPortfolioData: (company:IPortfolioCompany[]) => {
    dispatch(setAdditionalPortfolioData(company));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PortfolioApp);


